import { ModuleWithProviders, NgModule } from '@angular/core';

import { StorageProvider } from './storage.provider';

@NgModule({})
export class StorageModule {
  static forRoot(): ModuleWithProviders<StorageModule> {
    return {
      ngModule: StorageModule,
      providers: [
        StorageProvider,
      ],
    };
  }
}
